/* eslint-disable no-else-return */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import RadioForm from './RadioForm'
import TextAreaForm from './TextAreaForm'
import SearchInput from './SearchInput'

class Response extends Component {
  render() {
    if (!this.props) return null

    const { type, response, question } = this.props
    if (type === 'radioButton') {
      return (
        <div role="group" aria-label={question}>
          <RadioForm {...this.props} name="response" />
        </div>
      )
    } else if (type === 'searchInput') {
      return <SearchInput response={response} question={question} />
      // type text is neighter supported nor used it
    } else if (type === 'text') {
      return <TextAreaForm {...this.props} value="" />
    }
  }
}

export default connect(null, null)(Response)
